module.exports = __webpack_public_path__ + "img/about1.df13ebb8.webp";